import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step4View from './Step4-view';
import {loadOptionsByDDType} from '../../actions/loadOptionsByDDType';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {ddTypes} from '../../constants/dropdownTypes';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step4 = ({
                 submitStep,
                 regType,
                 payload,
                 language,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse
               }) => {
  const {bankName, ...restPayload} = payload;
  const initialValues = {
    bankName: bankName ? {value: bankName} : '',
    branchNum: '',
    accountNum: '',
    checkOnly: false,
    ...restPayload
  };

  const validate = values => {
    const {
      bankName,
      branchNum,
      accountNum,
      checkOnly
    } = values;
    let errors = {};

    if (!checkOnly) {
      errors = checkRequiredValues({
        bankName,
        branchNum,
        accountNum,
      }, errors);
    }

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {checkOnly} = values;
    const submit = (checkOnly) ? submitCheck : submitFields;

    submit(values)
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 4,
            step_name_en: 'Bank account details',
            step_name_he: formatMessage({id: 'step4.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.error({err}))
  };

  const submitCheck = values => {
    const {checkOnly} = values;

    return submitStep({
      step: 4,
      data: {
        regType,
        checkOnly,
        prevCompletedStepSign
      },
    })
  };

  const submitFields = values => {
    const {
      bankName: {value: bankName},
      branchNum,
      accountNum,
      checkOnly,
    } = values;
    const data = {
      regType,
      prevCompletedStepSign,
      bankName,
      branchNum,
      accountNum,
      checkOnly,
    };

    return submitStep({
      step: 4,
      data,
    })
  };

  const loadOptions = ddType => (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType});
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({values, isValid, submitCount}) => (
        <Step4View
          loadOptions={{
            bank: loadOptions(ddTypes.bankItems)
          }}
          values={values}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step4.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  language: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func,
};

export default Step4;
